import {
  SpotifyLogo,
  ApplePodcastsLogo,
  RssSimple,
  GooglePodcastsLogo,
} from '@phosphor-icons/react';
import { ExternalLink } from 'shared/types';
import { ICON_SIZE } from '../constants/common';

export type PodcastProvider = 'spotify' | 'apple' | 'google' | 'rss';

export const PODCAST_PROVIDERS: PodcastProvider[] = ['spotify', 'apple', 'google', 'rss'];

export const PODCAST_PROVIDER_MAP: Record<PodcastProvider, ExternalLink> = {
  spotify: {
    icon: <SpotifyLogo size={ICON_SIZE} />,
    label: 'Spotify',
    href: '#',
  },
  apple: {
    icon: <ApplePodcastsLogo size={ICON_SIZE} />,
    label: 'Apple',
    href: '#',
  },
  google: {
    icon: <GooglePodcastsLogo size={ICON_SIZE} />,
    label: 'Google',
    href: '#',
  },
  rss: {
    icon: <RssSimple size={ICON_SIZE} />,
    label: 'RSS',
    href: '#',
  },
};
